import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 8000 } // 8 seconds
  };

  connect() {
    this.element.classList.add("notification--entering");

    requestAnimationFrame(() => {
      this.element.classList.remove("notification--entering");
    });

    // Auto-dismiss after delay
    if (this.dismissAfterValue > 0) {
      this.timeoutId = setTimeout(() => {
        this.dismiss();
      }, this.dismissAfterValue);
    }
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  dismiss() {
    // Clear the timeout if dismissing manually
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.element.classList.add("notification--leaving");

    setTimeout(() => {
      this.element.remove();
    }, 300);
  }
}
